module.exports = __webpack_public_path__ + "static/img/img1.b46c4d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feature/img1.png
// module id = dy/b
// module chunks = 1